import React, { useState } from 'react';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from './alert-dialog';
import { AlertTriangle } from 'lucide-react';

/**
 * Diálogo de confirmación reutilizable para acciones destructivas.
 *
 *   <ConfirmDeleteDialog
 *     open={open}
 *     onOpenChange={setOpen}
 *     resource="contacto"
 *     itemName="Juan Pérez"
 *     onConfirm={async () => { await api.delete(id); }}
 *   />
 */
export const ConfirmDeleteDialog = ({
  open,
  onOpenChange,
  resource = 'elemento',
  itemName = '',
  description,
  onConfirm,
  testidPrefix = 'confirm-delete',
}) => {
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    setLoading(true);
    try {
      await onConfirm();
      onOpenChange?.(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid={`${testidPrefix}-dialog`}>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <span className="w-9 h-9 rounded-full bg-rose-50 text-rose-600 flex items-center justify-center">
              <AlertTriangle className="w-5 h-5" />
            </span>
            ¿Eliminar {resource}?
          </AlertDialogTitle>
          <AlertDialogDescription>
            {description || (
              <>
                Esta acción no se puede deshacer.
                {itemName && (
                  <> Se eliminará <span className="font-semibold text-ink-800">{itemName}</span> de forma permanente.</>
                )}
              </>
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={loading} data-testid={`${testidPrefix}-cancel`}>
            Cancelar
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={handleConfirm}
            disabled={loading}
            className="bg-rose-600 hover:bg-rose-700 focus:ring-rose-600"
            data-testid={`${testidPrefix}-confirm`}
          >
            {loading ? 'Eliminando…' : 'Eliminar'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default ConfirmDeleteDialog;
